const questionsReducer = (state = {data: null}, action) => {
    switch(action.type) {
        case "POST_QUESTION":
            // return{ ...state, data: action.payload}
            return{ ...state };

        case "POST_ANSWERS":
            return { ...state };

        case "POST_COMMENTS":
            return { ...state };

        case "EDIT_COMMENTS":
            return { ...state }; 

        case "FETCH_ALL_QUESTIONS":
            return { ...state, data: action.payload};
        
        default:
            return state
    }
}

export default questionsReducer